import { create } from "zustand"

interface Store {
  isOpened: boolean
  setIsOpened: (isOpened: boolean) => void
}

export const useAppSidebarStore = create<Store>()(set => ({
  isOpened: window.innerWidth > 1366,
  setIsOpened: (isOpened: boolean) => set({ isOpened }),
}))
